import ColorContrastChecker from 'color-contrast-checker'

import { CustomFieldType } from '@tribeplatform/gql-client/types'
import { Badge } from '@tribeplatform/react-ui-kit/Badge'

import {
  CustomFieldSubtype,
  CustomFieldViewProps,
  getFieldSetting,
} from '../utils.js'

export const PillView = ({
  value,
  field,
  trueText,
  falseText,
}: CustomFieldViewProps & { trueText: string; falseText: string }) => {
  const contrastChecker = new ColorContrastChecker()

  let text
  let color
  let textColor
  if (field?.type === CustomFieldType.boolean) {
    if (!trueText && !falseText) {
      trueText = 'Checked'
    }

    text = value ? trueText : falseText
    if (!text) {
      return null
    }
  } else {
    text = value
  }

  if (!text) {
    return null
  }

  const subtype = getFieldSetting(field, 'subtype')
  if (subtype === CustomFieldSubtype.SELECT) {
    const selectOptions = getFieldSetting(field, 'selectOptions')
    const currentOption = selectOptions?.find(option => option?.value === value)
    color = currentOption?.color
    if (color) {
      textColor =
        contrastChecker.hexToLuminance(color) < 0.5 ? '#ffffff' : '#000000'
    }
  }

  return (
    <div>
      <Badge
        size="lg"
        variant="secondary"
        style={{ backgroundColor: color, color: textColor }}
        className="max-w-full break-words"
      >
        <span className="min-w-0">{text}</span>
      </Badge>
    </div>
  )
}
